import { AiOutlineFundProjectionScreen } from "react-icons/ai";
import { Breadcrumb, Button, Modal, Tag, Space, Select, Spin, Menu, Dropdown, message, DatePicker, Checkbox } from "antd";
import { Link } from "react-router-dom";
import { useContext, useState, useEffect } from "react";
import { DashboardOutlined, PlusSquareOutlined, EyeOutlined, DownloadOutlined, UploadOutlined, DownOutlined } from "@ant-design/icons";
import { MdOutlineLibraryBooks } from "react-icons/md";
import { NAIRA } from "../../defaults/utilities";
import DataTable from "../../components/common/table";
import { formatCurrency } from "../../helpers/currency";
import CreateBudgetComponent from "../../components/dashboard/createBudgetComponent";
import PreviewBudget from "../../components/dashboard/previewBudgetItem";
import { DUMMY_FINANCIAL_YEAR_DATA } from "./year";
import Header from "../../components/dashboard/header";
import { useDownloadBudgetReport, useDownloadYearReport, useGetBudgets } from "../../hooks/budget/budgetQuery";
import RefreshContext from "../../context/refreshContext";
import { scrollToTop } from "../../helpers/dom";
import { useFetchAllYears } from "../../hooks/financialYear/financialYearQuery";
import { userStore } from "../../store/userStore";
import { useDepartments } from "../../hooks/department/departmentQuery";
import UploadRecord from "../../components/budgets/uploadRecords";
import BudgetReports from "../../components/budgets/budgetReport";



const NoDataComponent = () => {
  return (
    <h2>
      No data, Please Select Year
    </h2>
  )
}


function PreviewItem({ budgetItem, updateItem }) {
  const [previewShow, setPreviewShow] = useState(false);
  const closeModal = () => setPreviewShow(false);
  const openModal = () => setPreviewShow(true);

  return (
    <>
      <Space>
        <Button type="primary" onClick={openModal}>
          <EyeOutlined />
          View
        </Button>
        <Button type="primary" style={{ background: 'green' }} onClick={() => message.info("Implementation in progress")}>
          <EyeOutlined />
          Stats
        </Button>
      </Space>
      <Modal centered open={previewShow} title={'Budget Details'} width={"70vw"} onCancel={closeModal} footer={null}>
        <PreviewBudget item={budgetItem} updateItem={updateItem} handleModalClose={closeModal} />
      </Modal>
    </>
  )
}



export default function Budgets() {
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [status, setStatus] = useState(1)
  const [year, setYear] = useState(null);
  const [tempData, setTempData] = useState([]);
  const [fileUpload, setFileUpload] = useState(false)
  const [downloading, setDownloading] = useState(false)
  const [reporting, setReporting] = useState(false)
  const [showDownloading, setShowDownloading] = useState(false)
  const [reportQuery, setReportQuery] = useState({})

  const user = userStore(state => state.user);

  const { years } = useFetchAllYears();

  const { flag, setFlag } = useContext(RefreshContext);
  const getBudgets = useGetBudgets();
  const { departments } = useDepartments();
  const downloadBudgetReport = useDownloadBudgetReport();
  const downloadYearBudgetReport = useDownloadYearReport()

  const updateItem = (i) => {
    setData(data.map(d => {
      if (d.id === i.id) {
        d = i
      }
      return d
    }))
  }

  const BUDGET_DATA_COLUMNS = [
    {
      title: 'S/N',
      key: 's/n',
      render: (_, __, idx) => idx + 1
    },
    {
      title: 'Title',
      dataIndex: 'title',
      key: 'item'
    },
    {
      title: 'Amount',
      render: (_, { budgetItems }) => `${NAIRA} ${formatCurrency(budgetItems?.map(b => b.amount)?.reduce((i, c) => i + c, 0)) ?? 0.0}`,
    },
    {
      title: 'Office',
      dataIndex: 'office',
      key: 'office',
      render: (_, { office }) => office?.title ?? "None"
    },
    {
      title: 'Final Approval',
      dataIndex: 'finalApproved',
      key: 'final',
      render: (_, { finalApproved }) => {
        const isApproved = (<Tag color="green">Approved</Tag>);

        const notApproved = <Tag color="volcano">Not Approved</Tag>;

        return finalApproved ? isApproved : notApproved;
      }
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, item) => (
        <>
          <Space>
            <PreviewItem budgetItem={item} updateItem={updateItem} />
          </Space>
        </>
      )
    }
  ]


  useEffect(() => {
    scrollToTop();
  }, []);



  const handleStatusSearch = async (value) => {
    if (year) {
      setLoading(true);
      const response = await getBudgets(year, value);
      setLoading(false);
      setData(response.content ?? []);
      setTempData(response.content)
    }
    setStatus(value)
  }

  const handleYearSearch = async (value) => {
    setYear(value)
    setLoading(true);
    const response = await getBudgets(value, status);
    setLoading(false);
    setData(response.content ?? []);
    setTempData(response.content)
  }

  const downloadReport = async (combined) => {
    if (year) {
      setDownloading(true)
      const d = await downloadBudgetReport(null, year, combined)
      setDownloading(false)
    }
  }

  const downloadYearReport = async () => {
    try{
      setDownloading(true)
      const d = await downloadYearBudgetReport(year, reportQuery.start, reportQuery.end, reportQuery.current)
    } finally{
      setDownloading(false)
    }
  }

  const downloadMenu = (
    <Menu>
      <Menu.Item key="1" onClick={() => downloadReport(true)}>Combined Report</Menu.Item>
      <Menu.Item key="2" onClick={() => downloadReport(false)}>Individual Report</Menu.Item>
    </Menu>
  );

  const showCreateModal = () => setIsOpen(true);
  const hideCreateModal = () => setIsOpen(false);
  const toggleUploadModal = () => setFileUpload(!fileUpload);
  return (
    <>
      <div className="main-container">
        <Header />
        <div className="main-body">

          <div className="info-bar">
            <Breadcrumb>
              <Breadcrumb.Item>
                <DashboardOutlined className="dashboard-icon" />
                <Link to={"/dashboard"}>Dashboard</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <AiOutlineFundProjectionScreen />
                <Link to="/dashboard/budgets">Budgets</Link>
              </Breadcrumb.Item>
            </Breadcrumb>
            <div>
              <Select
                showSearch
                placeholder="Status"
                onChange={handleStatusSearch}
                filterOption={(input, option) =>
                  (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
                style={{
                  width: 120,
                }}
                options={[
                  {
                    value: 1,
                    label: 'All'
                  },
                  {
                    value: 2,
                    label: 'Approved'
                  },
                  {
                    value: 3,
                    label: 'Unapproved'
                  }
                ]}
              />
            </div>
            <div>
              <Select
                showSearch
                placeholder="Year"
                onChange={handleYearSearch}
                filterOption={(input, option) =>
                  (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
                style={{
                  width: 150,
                }}
                options={[...years.map(year => ({ value: year.id, label: year.value }))]}
              />
            </div>
            {
              user?.roles?.includes("CREATE_BUDGET") && !reporting &&
              <>
                <div>
                  <Button style={{ backgroundColor: "green", color: "#FFFFFF" }} onClick={showCreateModal}>
                    <PlusSquareOutlined />
                    New
                  </Button>
                </div>
                <div>
                  <Button disabled={!year} style={{ backgroundColor: "green", color: "#FFFFFF" }} onClick={toggleUploadModal}>
                    <UploadOutlined />
                    Upload
                  </Button>
                </div>
              </>
            }
            <div>
              <div style={{
                display: 'flex',
              }}>
                {
                  reporting &&
                  <Button style={{
                    marginRight: '.2em'
                  }} loading={downloading} disabled={!year} onClick={() => setShowDownloading(true)} >
                    Download
                  </Button>
                }
                <Button disabled={!year} onClick={() => setReporting(!reporting)} style={{ backgroundColor: reporting ? 'red' : "green", color: "#FFFFFF" }} >
                  {reporting ? 'Back' : 'Reporting'}
                </Button>
              </div>
              {/*<Dropdown  disabled={!year} overlay={downloadMenu} trigger={['click']}>*/}
              {/*    <Button loading={downloading} disabled={!year} style={{ backgroundColor: "green", color: "#FFFFFF" }} >*/}
              {/*        <DownloadOutlined />*/}
              {/*        Report*/}
              {/*    </Button>*/}
              {/*</Dropdown>*/}
            </div>
          </div>

          <div className="table-section">
            <Spin spinning={loading}>
              {
                !reporting ?
                  <DataTable cols={BUDGET_DATA_COLUMNS} data={data} locale={{
                    emptyText: <NoDataComponent />
                  }} /> :
                  <BudgetReports year={year} status={status} />
              }
            </Spin>
          </div>
        </div>
      </div>
      <Modal centered title="Create a new Budget" open={isOpen} footer={null} onCancel={hideCreateModal} width={"65vw"}>
        <CreateBudgetComponent toggleOpen={() => setIsOpen(false)} />
      </Modal>
      <Modal centered title="Upload budgets" open={fileUpload} footer={null} onCancel={toggleUploadModal} width={"30vw"}>
        <UploadRecord onUpload={toggleUploadModal} />
      </Modal>

      <Modal centered title="Download year report" open={showDownloading} footer={null} onCancel={() => {setShowDownloading(false); setReportQuery({})}} width={"30vw"}>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          marginTop: '1.5em'
        }}>
          <DatePicker placeholder="Start month" style={{width:'100%'}} onChange={(date,str)=>setReportQuery({...reportQuery, start: `${str}-01`})} picker="month" />
          <DatePicker placeholder="Start month" style={{width:'100%', marginTop: '2em'}} onChange={(date,str)=>setReportQuery({...reportQuery, end: `${str}-01`})} picker="month" />
          <Checkbox style={{marginTop: '2em'}} onChange={e => setReportQuery({...reportQuery, current: e.target.checked})}> Show current performance column </Checkbox>
          <div style={{
            display: 'flex',
            justifyContent: 'flex-end',
            marginTop: '3em'
          }}>
            <Button style={{
              backgroundColor: 'green', color: 'white'
            }} loading={downloading} disabled={!reportQuery.start || !reportQuery.end} onClick={() => downloadYearReport()}>Download</Button>
          </div>
        </div>
      </Modal>
    </>
  )
}
